import { render } from "./RoomCalendar.vue?vue&type=template&id=5b0222fb&scoped=true"
import script from "./RoomCalendar.vue?vue&type=script&lang=js"
export * from "./RoomCalendar.vue?vue&type=script&lang=js"

import "./RoomCalendar.vue?vue&type=style&index=0&id=5b0222fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0222fb"]])

export default __exports__